import $ from 'jquery';
/*import Headroom from 'headroom.js';*/
import 'jquery.rateit';
//not: sticky kaldirildi
//const header = $('.site-header')[0];
//const headroom = new Headroom(header);
//headroom.init();

$('.brandex-stars').each(function () {
    const val = $(this).attr('data-rateit-value').replace(',', '.');
    $(this).attr('data-rateit-value', val).rateit();
});
//header sticky kaldirildi, iler de tekrar aktif edilebilir...
//const headerAutomation = () => {
//    $(window).scroll(function (e) {
//        const topPos = $(window).scrollTop();
//        const searchPos = $('#SearchForm').offset().top;
//        const header = $('.site-header');
//        const headerHeight = header.outerHeight();
//        const searchInput = $('#mainhead__search');
//        const inputHeight = searchInput.outerHeight();

//        if (topPos >= searchPos + inputHeight - headerHeight) {
//            header.addClass('site-header-with-search');
//        } else {
//            header.removeClass('site-header-with-search');
//        }
//    });
//};

//if ($('body').hasClass('homepage-wrapper')) {
//    headerAutomation();
//}

$('.language-switcher').on('change', function () {
    const val = $(this).val();
    const url = new URL(window.location.href);
    window.location.href = `${url.origin}/${val}`;
});

$('body').on('click', '.open-search-box', function () {
    $('.site-header').toggleClass('search-active');
    $(this).find('i').toggleClass('fa-search fa-times');

    if ($('.site-header').hasClass('search-active')) {
        setTimeout(() => {
            $('#mainhead__search').focus();
        }, 300);
    }
});
